import EventEmitter from 'eventemitter2';

export const PLAY = 'play';
export const PAUSE = 'pause';
export const PLAYFINISH = 'play_finish';

export const GET_AUDIO_SENDING_STATUS = 'getAudioSendingStatus';
export const START_SEND_AUDIO = 'startSendAudio';
export const SEND_MESSAGE = 'sendMessage';
export const CLOSE = 'CLOSE';

const bus = new EventEmitter();

// 更改最大监听数
bus.setMaxListeners(30);

export {
  bus,
};
